/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './error.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../app/error/error.component';
import * as i4 from '@angular/router';
const styles_ErrorComponent:any[] = [i0.styles];
export const RenderType_ErrorComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ErrorComponent,data:{}});
function View_ErrorComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'p',[['class',
      'error-reference']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(1,(null as any),['Reference: ','']))],(null as any),
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.errorReference;
        _ck(_v,1,0,currVal_0);
      });
}
export function View_ErrorComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),22,'div',[['class',
      'container']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵeld(4,0,(null as any),(null as any),17,'div',[['class','row']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['\n    '])),(_l()(),i1.ɵeld(6,0,(null as any),(null as any),
          14,'div',[['class','col-xs-12']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i1.ɵeld(8,0,(null as any),(null as any),0,'p',[['class','error-text']],
          [[8,'innerHTML',1]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['  '])),(_l()(),i1.ɵeld(10,0,(null as any),
          (null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i1.ɵeld(12,0,(null as any),(null as any),4,'p',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['For all other issues, please contact\n        '])),(_l()(),
          i1.ɵeld(14,0,(null as any),(null as any),1,'a',[['href','mailto:service@riskandsafety.com']],
              (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['service@riskandsafety.com'])),(_l()(),i1.ɵted(-1,
          (null as any),['\n      '])),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ErrorComponent_1)),
      i1.ɵdid(19,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i3.ErrorComponent = _v.component;
    const currVal_1:any = _co.errorReference;
    _ck(_v,19,0,currVal_1);
  },(_ck,_v) => {
    var _co:i3.ErrorComponent = _v.component;
    const currVal_0:any = _co.getErrorMsg();
    _ck(_v,8,0,currVal_0);
  });
}
export function View_ErrorComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'error',([] as any[]),
      (null as any),(null as any),(null as any),View_ErrorComponent_0,RenderType_ErrorComponent)),
      i1.ɵdid(1,114688,(null as any),0,i3.ErrorComponent,[i4.ActivatedRoute],(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ErrorComponentNgFactory:i1.ComponentFactory<i3.ErrorComponent> = i1.ɵccf('error',
    i3.ErrorComponent,View_ErrorComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc2xpcHJlc2lzdGFudC9zbGlwcmVzaXN0YW50L2NsaWVudC9zcmMvYXBwL2Vycm9yL2Vycm9yLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3J1bm5lci93b3JrL3NsaXByZXNpc3RhbnQvc2xpcHJlc2lzdGFudC9jbGllbnQvc3JjL2FwcC9lcnJvci9lcnJvci5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL3J1bm5lci93b3JrL3NsaXByZXNpc3RhbnQvc2xpcHJlc2lzdGFudC9jbGllbnQvc3JjL2FwcC9lcnJvci9lcnJvci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvc2xpcHJlc2lzdGFudC9zbGlwcmVzaXN0YW50L2NsaWVudC9zcmMvYXBwL2Vycm9yL2Vycm9yLmNvbXBvbmVudC50cy5FcnJvckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJjb250YWluZXJcIj5cbiAgPGJyLz5cbiAgPGRpdiBjbGFzcz1cInJvd1wiPlxuICAgIDxkaXYgY2xhc3M9XCJjb2wteHMtMTJcIj5cbiAgICAgIDxwIFtpbm5lckhUTUxdPVwiZ2V0RXJyb3JNc2coKVwiIGNsYXNzPVwiZXJyb3ItdGV4dFwiPjwvcD4gIDxici8+XG4gICAgICA8cD5Gb3IgYWxsIG90aGVyIGlzc3VlcywgcGxlYXNlIGNvbnRhY3RcbiAgICAgICAgPGEgaHJlZj1cIm1haWx0bzpzZXJ2aWNlQHJpc2thbmRzYWZldHkuY29tXCI+c2VydmljZUByaXNrYW5kc2FmZXR5LmNvbTwvYT5cbiAgICAgIDwvcD5cbiAgICAgIDxwICpuZ0lmPVwiZXJyb3JSZWZlcmVuY2VcIiBjbGFzcz1cImVycm9yLXJlZmVyZW5jZVwiPlJlZmVyZW5jZToge3tlcnJvclJlZmVyZW5jZX19PC9wPlxuICAgIDwvZGl2PlxuICA8L2Rpdj5cbjwvZGl2PlxuIiwiPGVycm9yPjwvZXJyb3I+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDUU07TUFBQTtNQUFBLGdCQUFrRDs7O1FBQUE7UUFBQTs7OztvQkFSeEQ7TUFBQTtNQUF1Qiw0Q0FDckI7VUFBQTtVQUFBLDhCQUFLO01BQ0w7VUFBQSwwREFBaUI7VUFBQSwyQkFDZjtVQUFBO1VBQUEsOEJBQXVCO01BQ3JCO1VBQUE7TUFBc0QsMENBQUU7VUFBQTtVQUFBLDhCQUFLO01BQzdEO1VBQUEsMERBQUc7VUFBQSxtRUFDRDtpQkFBQTtjQUFBO01BQTJDLGlFQUE2QjtVQUFBLDZCQUN0RTtNQUNKO2FBQUE7VUFBQSxpQ0FBbUY7TUFDL0UsNENBQ0Y7VUFBQSxTQUNGOztJQUhHO0lBQUgsWUFBRyxTQUFIOzs7SUFKRztJQUFILFdBQUcsU0FBSDs7OztvQkNKTjtNQUFBO2FBQUE7VUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/$$_gendir/app/error/error.component.ngfactory.ts